module.exports = __webpack_public_path__ + "assets/adpoly-facility-clinics-bulk-upload-template.2644397c.xlsx";